import styled from 'styled-components';
import config from '../../../config';
import './style.scss';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {useState, useEffect, useRef} from 'react';
import {createPortal} from 'react-dom';

const HeaderOuter = styled.header`
  z-index: 3;
  width: 100%;
  display: block;
  height: 55px;
  background-color: #F8F8F8;
  transition: background-color 0.3s ease-out;
  position: fixed;
  top: 0;
  left: 0;
  border-bottom: 1px solid #D9D9D9;

  &.top {
    border-bottom-color: transparent;
  }

  svg {
    .hlst0 {
      fill: #000000;
      transition: fill 0.3s ease-out;
    }
  }

  @media ${config.layout.mobile} {
    &.opened {
      background-color: #000000;
      border-bottom-color: transparent;

      svg {
        .hlst0 {
          fill: #ffffff;
        }
      }
    }
  }

  @media ${config.layout.wide} {
    min-width: 1200px;
    display: flex;
    align-items: center;
    position: sticky;
    top: -60px;
    height: 160px;
  }
`;

const HeaderInner = styled.div`
  height: 100%;
  @media ${config.layout.wide} {
    height: 100px;
    width: 100%;
    min-width: 1200px;
    position: sticky;
    top: 0;
    padding-top: calc((100px - 66px) / 2);
  }
`;

const HeaderContent = styled.div`

  svg {
    width: 116px;
  }

  
  
  @media ${config.layout.wide} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    margin: 0 60px 0 50px;
    height: 66px;

    svg {
      width: 165px;
      height: 66px;
    }
  }
`;

const HeaderMenuArea = styled.div`
  @media ${config.layout.mobile} {
    width: 100vw;
    background: #000000;
    height: calc(100vh - 55px);
    position: fixed;
    top: 55px;
    display: none;
    &.opened {
      display: block;
    }
    overflow-y: scroll;
  }
  @media ${config.layout.wide} {

  }
`;

const HeaderMenuItems = styled.div`
  @media ${config.layout.mobile} {
    height: calc(100% + 20px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 50px;
    gap: 40px;
  }
  @media ${config.layout.wide} {
    display: flex;
    align-items: center;
    gap: 54px;
    position: relative;
  }
`;

const HeaderMenuLinkElm = styled.a`
  text-decoration: none;

  @media ${config.layout.mobile} {
    color: #fff;
    font-size: 32px;
    font-weight: bold;
    line-height: 1em;
    &:hover {
      color: #fff;
    }
  }

  @media ${config.layout.wide} {
    color: #000;
    font-weight: bold;
    top: 13px;
    position: relative;
    &:hover {
      color: #000;

      &:after {
        content: '';
        display: block;
        height: 4px;
        background-color: #000;
        position: absolute;
        bottom: -6px;
        width: 100%;
      }
    }
  }
`;

const HeaderLogoLinkElm = styled.a`
  display: block;

  @media ${config.layout.mobile} {
    position: absolute;
    left: calc(50% - (116px / 2) + 2px);
    top: 5px;
  }

  @media ${config.layout.wide} {

  }
`;

const HeaderMenuButtonElm = styled.div`

  position: absolute;
  width: 20px;
  height: 20px;
  right: 15px;
  top: 15px;

  &:before {
    content: '';
    display: block;
    width: 20px;
    height: 4px;
    position: absolute;
    left: 0;
    top: 3px;
    background-color: #000;
    transition: transform 0.3s ease-out, background-color 0.3s ease-out;
  }

  &:after {
    content: '';
    display: block;
    width: 20px;
    height: 4px;
    position: absolute;
    left: 0;
    top: 12px;
    background-color: #000;
    transition: transform 0.3s ease-out, background-color 0.3s ease-out;
  }

  &.opened {
    &:before {
      width: 22px;
      left: -1px;
      top: 8px;
      transform: rotateZ(45deg);
      background-color: #fff;
    }

    &:after {
      width: 22px;
      left: -1px;
      top: 8px;
      transform: rotateZ(-45deg);
      background-color: #fff;
    }
  }

  @media ${config.layout.wide} {
    display: none;
  }
`;

function HeaderLogoLink({
  closeModal,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  //console.log(location);

  if (location.pathname == '/') {
    // 同じページ内に既にいる
    return (
        <HeaderLogoLinkElm
            href={'#'}
            onClick={(e) => {
              e.preventDefault();
              closeModal();
              if (location.hash) {
                navigate('/');
              } else {
                window.scrollTo(0, 0);
//                window.location.reload();
              }
            }}
        >
          <HeaderLogo/>
        </HeaderLogoLinkElm>
    );
  }

  const onClick = (e) => {
    e.preventDefault();
    closeModal();
    navigate('/');
  };

  return (
      <HeaderLogoLinkElm href="#" onClick={onClick}>
        <HeaderLogo/>
      </HeaderLogoLinkElm>
  );
}

export function HeaderLogo() {
  return (
      <svg version="1.1" id="header-logo" xmlns="http://www.w3.org/2000/svg"
           x="0px"
           y="0px" viewBox="0 0 165 66"
           style={{'enableBackground': 'new 0 0 165 66'}}>
        <g id="hlgroup_1" transform="translate(-204.232 -202.318)">
          <g id="hlgroup_957" transform="translate(204.232 215.585)">
            <path id="hlpath_121" className="hlst0" d="M87.38,31.24c0.1,0.26,0.4,0.38,0.65,0.27c0.13-0.05,0.23-0.16,0.28-0.29l9.42-28.64h6.17
			L92.77,33.86c-0.72,2.24-2.93,3.65-5.26,3.38c-2.71-0.08-4.2-1.16-5.17-3.81L71.36,2.61h6.29L87.38,31.24z"/>
            <rect id="hlrect_716" x="0.48" y="2.6" className="hlst0"
                  width="5.65"
                  height="34.41"/>
            <path id="hlpath_122" className="hlst0" d="M65.34,13.06c-0.19-1.56-1.61-2.68-3.18-2.48c-1.4,0.17-2.47,1.35-2.5,2.76l0,0l-0.01,10.11
			c-0.15,4.88-4.22,8.72-9.1,8.57c-2.67-0.08-5.16-1.36-6.78-3.49c-1.08-1.56-1.62-3.42-1.55-5.31V2.6h-5.76l0.01,20.6
			c-0.01,0.72,0.04,1.44,0.12,2.15c0.4,4.19,2.79,7.93,6.43,10.04c2.85,1.67,6.17,2.37,9.45,2c3.35-0.2,6.52-1.6,8.92-3.94
			c2.67-2.63,4.12-6.24,4.02-9.99L65.34,13.06z"/>
            <circle id="hlel_42" className="hlst0" cx="62.48" cy="5.51"
                    r="2.88"/>
            <path id="hlpath_123" className="hlst0" d="M136.98,6.95c-5.42-5.42-13.69-6.79-20.57-3.41l2.45,5.22c6-3.02,13.3-0.6,16.32,5.4
			c3.02,6,0.6,13.3-5.4,16.32c-6,3.02-13.3,0.6-16.32-5.4c-0.59-1.17-0.98-2.43-1.17-3.73l0,0c-0.19-1.58-1.63-2.7-3.21-2.5
			c-1.58,0.19-2.7,1.63-2.5,3.21c0.01,0.06,0.02,0.12,0.03,0.18l0,0c1.44,9.79,10.55,16.55,20.33,15.1
			c9.79-1.44,16.55-10.55,15.1-20.33C141.48,13.19,139.71,9.67,136.98,6.95L136.98,6.95z"/>
            <circle id="hlel_43" className="hlst0" cx="109.99" cy="13.69"
                    r="2.9"/>
            <path id="hlpath_124" className="hlst0" d="M15.53,20.22c-0.54-0.44-0.62-1.23-0.18-1.77c0.06-0.07,0.13-0.14,0.2-0.2l13.8-15.66h-7.07
			L10.41,16.16c-2.05,2.51-2.02,4.52,0.08,6.98l11.97,13.9l7.4-0.01L15.53,20.22z"/>
          </g>
          <g id="hlgroup_958" transform="translate(345.916 202.318)">
            <path id="hlpath_125" className="hlst0" d="M11.33,7.6c-0.35,0-0.68,0.12-0.94,0.35c-0.28,0.25-0.46,0.6-0.52,0.98l-0.84,4.76
			c0.38,0.26,0.83,0.39,1.29,0.36c0.39,0.01,0.77-0.11,1.08-0.36c0.29-0.23,0.48-0.56,0.54-0.92c0.09-0.36,0.04-0.74-0.16-1.05
			c-0.23-0.27-0.58-0.42-0.94-0.38h-0.61l0.23-1.33h0.49c0.72-0.02,1.15-0.45,1.29-1.27c0.07-0.29,0.01-0.59-0.16-0.83
			C11.91,7.7,11.62,7.58,11.33,7.6z"/>
            <path id="hlpath_126" className="hlst0" d="M10.5,1.71C4.97,1.71,0.48,6.2,0.48,11.73s4.49,10.03,10.03,10.02
			c5.54,0,10.02-4.49,10.02-10.03C20.53,6.2,16.04,1.71,10.5,1.71C10.5,1.71,10.5,1.71,10.5,1.71z M14.09,8.61
			c-0.07,0.42-0.25,0.81-0.51,1.14c-0.28,0.34-0.63,0.62-1.03,0.81c0.44,0.14,0.81,0.44,1.03,0.84c0.21,0.43,0.27,0.93,0.16,1.4
			c-0.11,0.78-0.5,1.49-1.1,2c-0.62,0.49-1.39,0.74-2.17,0.72c-0.59,0.02-1.18-0.15-1.68-0.48l-0.51,2.89H6.48l1.59-9.02
			C8.16,8.4,8.38,7.91,8.71,7.5c0.34-0.43,0.78-0.77,1.27-0.99c0.5-0.24,1.05-0.36,1.6-0.36c0.74-0.06,1.47,0.18,2.03,0.65
			C14.08,7.28,14.26,7.97,14.09,8.61L14.09,8.61z"/>
          </g>
        </g>
      </svg>
  );
}

function HeaderLink({
  to, closeModal, children,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  //console.log(location);

  let toPath = to.replace(/#.*?$/, '');
  if (toPath == location.pathname) {
    // 同じページ内に既にいる

    if (location.hash || to.replace(/^.+?#/, '')) {
      return (
          <HeaderMenuLinkElm
              data-hashlink={1}
              href={to}
              onClick={(e) => {
                closeModal();
                global.scrollToHash(`#${to.replace(/^.+?#/, '')}`);
              }}
          >
            <span>{children}</span>
          </HeaderMenuLinkElm>
      );
    } else {
      return (
          <HeaderMenuLinkElm
              data-hashlink={1}
              href={'#'}
              onClick={(e) => {
                e.preventDefault();
                closeModal();
                window.scrollTo(0, 0);
              }}
          >
            <span>{children}</span>
          </HeaderMenuLinkElm>
      );
    }
  }

  const onClick = (e) => {
    e.preventDefault();
    closeModal();
    navigate(to);
  };

  return (
      <HeaderMenuLinkElm href="#" onClick={onClick}>
        <span>{children}</span>
      </HeaderMenuLinkElm>
  );
}

function HeaderModalButton({
  toggleModal, isOpen,
}) {
  return (
      <HeaderMenuButtonElm className={isOpen ? 'opened' : 'closed'}
                           onClick={toggleModal}/>
  );
}

export default function HeaderNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  return (
      <HeaderOuter className={`header ${isOpen
          ? 'opened'
          : 'closed'} ${location.pathname == '/' ? 'top' : ''}`}
                   id={'nav-header'} >
        <HeaderInner>
          <HeaderContent>
            <HeaderLogoLink closeModal={closeModal}/>
            <HeaderModalButton toggleModal={toggleModal} isOpen={isOpen}/>
            <HeaderMenuArea className={isOpen ? 'opened' : 'closed'}>
              <HeaderMenuItems>
                <HeaderLink to={'/'} closeModal={closeModal}>TOP</HeaderLink>
                <HeaderLink to={'/#about'}
                            closeModal={closeModal}>ABOUT</HeaderLink>
                <HeaderLink to={'/#services'}
                            closeModal={closeModal}>SERVICES</HeaderLink>
                <HeaderLink to={'/faq/'}
                            closeModal={closeModal}>FAQ</HeaderLink>
                <HeaderLink to={'/contact/'}
                            closeModal={closeModal}>CONTACT</HeaderLink>
              </HeaderMenuItems>
            </HeaderMenuArea>
          </HeaderContent>
        </HeaderInner>
      </HeaderOuter>
  );

}
